// extracted by mini-css-extract-plugin
export var label = "_dt-5";
export var slideContainer = "_dt-0";
export var slider = "_dt-1";
export var sliderLg = "_dt-4";
export var sliderMd = "_dt-3";
export var sliderSm = "_dt-2";